import React from "react";
import { useRoutes, Navigate } from "react-router-dom";
import Login from "../pages/user/login/Login";
import OtpVerify from "../pages/user/otp-verify/OtpVerify";
import MainLayout from "../layout/MainLayout";
import AuthLayout from "layout/auth-layout/AuthLayout";
import ForgetPassword from "pages/user/forget-password/ForgetPassword";
import ChangePassword from "pages/user/change-password/ChangePassword";
import ForgetPasswordResult from "pages/user/forget-password-result/ForgetPasswordResult";
import ChangePasswordResult from "pages/user/change-password-result/ChangePasswordResult";
import TokenExpired from "pages/user/token-expired/TokenExpired";

const RoutesConfig = () => {
  const routes = useRoutes([
    {
      path: "/",
      index: true,
      element: <Navigate to="/user/login" />,
    },
    {
      path: "/user",
      element: <AuthLayout />,
      children: [
        {
          path: "login",
          element: <Login />,
        },
        {
          path: "forget-password",
          element: <ForgetPassword />,
        },
        {
          path: "forget-password-result",
          element: <ForgetPasswordResult />,
        },
        {
          path: "change-password",
          element: <ChangePassword />,
        },
        {
          path: "change-password-result",
          element: <ChangePasswordResult />,
        },
        {
          path: "otp-verify",
          element: <OtpVerify />,
        },
        {
          path: "token-expired",
          element: <TokenExpired />,
        },
      ],
    },
    {
      path: "/master",
      element: <MainLayout />,
    },
    {
      path: "*",
      element: <MainLayout />,
    },

    // {
    //   path: '/blogs',
    //   element: <Blogs />
    // },
    // {
    //   path: '/contact',
    //   element: <Contact />
    // },
    // {
    //   path: '*',
    //   element: <404NotFound />
    // },
  ]);
  return routes;
};

export default RoutesConfig;
